import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {callAction} from 'client/framework';
import supplementEditorActions from 'client/Supplements/SupplementEditor/SupplementEditor.actions';
import TextInput from 'client/generic/Forms/TextInput/TextInput.react';
import TextArea from 'client/generic/Forms/TextArea/TextArea.react';
import Checkbox from 'client/generic/Forms/Checkbox/Checkbox.react';
import Passage from './Passage.react';
import {AuthoringSupplement as AuthoringSupplementModelV1} from 'resources/GeneratedModels/AuthoringSupplement/AuthoringSupplementModel.v1';
import './passage-editor.scss';

export default class PassageEditor extends React.Component {
  static propTypes = {
    supplement: PropTypes.instanceOf(AuthoringSupplementModelV1),
    onChange: PropTypes.func,
    onCheckChange: PropTypes.func,
    errors: ImmutablePropTypes.map
  };

  UNSAFE_componentWillMount() {
    const supplement = this.props.supplement;
    const hideLineNumbers = supplement.getContent().get('hideLineNumbers', false);
    const ignoreWhiteSpace = supplement.getContent().get('ignoreWhiteSpace', false);
    const excludeWhiteSpace = supplement.getContent().get('excludeWhiteSpace', false);
    callAction(supplementEditorActions.MODIFY_ACTIVE_SUPPLEMENT, [
      {
        setter: 'setHideLineNumbersOnContentMap',
        value: hideLineNumbers
      },
      {
        setter: 'setIgnoreWhiteSpace',
        value: ignoreWhiteSpace
      },
      {
        setter: 'setExcludeWhiteSpace',
        value: excludeWhiteSpace
      }
    ]);
  }

  render() {
    const supplement = this.props.supplement;
    const hideLineNumbers = supplement.getContent().get('hideLineNumbers', false);
    const ignoreWhiteSpace = supplement.getContent().get('ignoreWhiteSpace', false);
    const excludeWhiteSpace = supplement.getContent().get('excludeWhiteSpace', false);
    const errors = this.props.errors;
    return (
      <div className='passage-editor'>
        <div className='passage-editor__fieldset'>
          <TextInput
            className='passage-editor__input'
            data-setter-method='setName'
            error={Boolean(errors.get('name'))}
            errorMessage={errors.get('name', null)}
            label='Name'
            name='name'
            onChange={this.props.onChange}
            value={supplement.getName()}
          />
          <TextArea
            className='passage-editor__input passage-editor__input--textarea'
            data-setter-method='setText'
            error={Boolean(errors.get('text'))}
            errorMessage={errors.get('text', null)}
            label='Text'
            name='text'
            onChange={this.props.onChange}
            value={supplement.getText()}
          />
          <Checkbox
            className='passage-editor__input passage-editor__input--checkbox'
            checked={hideLineNumbers}
            data-setter-method='setHideLineNumbersOnContentMap'
            label='Hide line numbers'
            name='hideLineNumbers'
            onChange={this.props.onCheckChange}
          />
          <Checkbox
            className='passage-editor__input passage-editor__input--checkbox'
            checked={ignoreWhiteSpace}
            data-setter-method='setIgnoreWhiteSpace'
            label='Ignore white space'
            name='ignoreWhiteSpace'
            onChange={this.props.onCheckChange}
          />
          <Checkbox
            className='passage-editor__input passage-editor__input--checkbox'
            checked={excludeWhiteSpace}
            data-setter-method='setExcludeWhiteSpace'
            label='Exclude white space from line count'
            name='excludeWhiteSpace'
            onChange={this.props.onCheckChange}
          />
        </div>
        <div className='passage-editor-preview__wrapper'>
          <div className='a-form-input__label'>Preview</div>
          <Passage className='passage-editor__passage-preview' content={supplement.getContent()} />
        </div>
      </div>
    );
  }
}
